export default "__VITE_ASSET__BHVGo7Ix__"